<template>
  <div class="wrap">
    <div class="swiper">
      <div class="title_userinfo">
        <div class="userInfo_left">
          <img src="@/assets/logo/login.png" class="logo" alt="" />
        </div>
        <div class="right">
          <template v-if="token">
            <div class="userInfo">
              <div class="userInfo_left">
                <div class="left_name">{{ userInfo.username }}</div>
                <div class="left_money">{{ isHide ? $money('****') : $money(userInfo.money) }}</div>
              </div>
              <div class="userInfo_right">
                <div class="right_btn" @click="RechargeEvent">
                  <img src="../../assets/new/goods/deposit.png" alt="">
                </div>
                <div class="right_btn" @click="WithdrawEvent">
                  <img src="../../assets/new/goods/withdraw.png" alt="">
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="btn login">
              {{ $t("page.login") }}
            </div>
            <div class="btn register">
              {{ $t("page.registrasi") }}
            </div>
          </template>
          <div class="share_content" @click="overlayShow = true">
            <!-- <i class="iconfont icon-wodekefu btn_server_icon" @click="toService"></i> -->
            <img src="../../assets/new/goods/menu.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="banner_wrap">
      <Banner @itemClick="swiperClick" />
    </div>
    <div class="banner_wrap">
      <div class="notice">
        <van-notice-bar class="notice_bar" :text="noticeArr.join('，')" left-icon="volume-o" color="#961f1f"
          background="transparent" :scrollable="true" :speed="40" :delay="0" />
      </div>
    </div>
    <div class="jackpot-container">
      <div class="jackpot_bg">
        <div class="jackpot_num">
          <div :class="item != ',' && item != '.' ? 'num' : 'point'" v-for="(item, index) in jackpotNum" :key="index">
            <span>{{ item }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="game">
      <div class="game_wrap">
        <div class="game_item" :class="gameActive == index ? 'item_active' : ''" v-for="(item, index) in displayGameArr"
          :key="index" @click="gameClick(index)">
          <!-- <img :src="item.icon" alt="" v-if="index == 0" /> -->
          <img :src="$img(item.icon)" alt="" />
          <div class="title">{{ item.title }}</div>
        </div>
      </div>
    </div>
    <div class="shop_wrap">
      <div class="content_wrap">
        <!-- <template v-if="gameActive == 0">
          <div class="merchants_wrap">
            <div class="merchant_item" v-for="(item, index) in hotMerchants" :key="index" @click="toGame(item)"
              :class="item.type.includes('hl') ? 'hl' : item.type.includes('qq') ? 'qq' : ''">
              <div class="item_left">
                <div class="title">{{ item.title }}</div>
                <div class="subtitle">{{ item.subtitle }}</div>
                <div class="btn">{{ $t('下注') }}</div>
              </div>
              <img :src="item.picture" alt="" />
            </div>
          </div>
        </template> -->
        <template>
          <div class="merchants_wrap">
            <div class="merchant_item" v-for="(item, index) in gameList" :key="index" @click="toGames(item)"
              :class="item.type.includes('hl') ? 'hl' : item.type.includes('qq') ? 'qq' : ''"
              :style="{ backgroundImage: 'url(' + require(`../../assets/new/goods/game_bg_${gameActive}.png`) + ')' }">
              <div class="item_left">
                <div class="title">{{ item.title }}</div>
                <!-- <div class="subtitle">{{ item.subtitles.join(',') }}</div> -->
                <div class="btn">{{ $t('下注') }}</div>
              </div>
              <img :src="item.picture" alt="" />
              <!-- <div class="subtitle">{{ item.subtitle }}</div> -->
            </div>
          </div>
        </template>
        <!-- <div class="not_game" v-else>
          <img @click="noGameClick" :src="require(`../../assets/new/goods/game/${gameActive}.png`)" alt="">
        </div> -->
      </div>
    </div>
    <div class="hall" v-if="false">
      <!-- <div class="title">
        {{ $t("Home.HallofFame") }}
      </div> -->
      <HallMarquee class="marquee" :height="208" :num="merchants.length">
        <template v-slot="{ item }">
          <div class="item">
            <div class="left">
              <Avatar size="50" :src="merchants[item.num]?.picture"
                :defaultSrc="require('@tt/assets/defaultAvatar/A6405.png')" />
              <div class="info">
                <div class="info_game_name">{{ merchants[item.num]?.title }}</div>
                <div class="nick_name">
                  {{ item.name }}
                </div>
                <div class="info_money">{{ $money(item.money) }}</div>
              </div>
            </div>
            <div class="right" @click="toGame(merchants[item.num])">{{ $t('立即游戏') }}</div>
          </div>
        </template>
      </HallMarquee>
    </div>
    <!-- <div class="hall_bg">
      <img class="img" src="@/assets/home/home_bg.png" alt="" />
    </div> -->
    <van-dialog v-model="dialogShow" :showConfirmButton="false" close-on-click-overlay>
      <img style="width: 100%" :src="homeImg" />
      <div class="close">
        <van-icon class="icon" name="close" @click="dialogShow = false" />
      </div>
    </van-dialog>
    <!-- <Popup v-model="ruleIsShow">
      <img :src="require('@tt/assets/home/rule.jpg')" width="100vw" alt="">
    </Popup> -->

    <van-action-sheet v-model="show2" :actions="verConfig.lans || Lans" @close="onClose" @select="onSelect" />
    <van-overlay :show="overlayShow" @click="overlayShow = false" z-index="99">
      <div class="overlay">
        <div class="overlay_item" v-for="item, index in list" :key="index" @click.stop="item.callback">
          <img :src="isHide ? item.icon1 : item.icon" alt="" v-if="item.icon1">
          <img :src="item.icon" alt="" v-else>
          <span>{{ $t(item.title) }}</span>
        </div>
      </div>
    </van-overlay>
    <div class="checkIn" @click.stop="checkIn" :style="{ '--num': 0 }">
      <img src="@/assets/new/goods/checkIn.png" alt="">
    </div>
    <!-- <keep-alive>
      <div v-show="serviceOpen" class="transtions">
        <div class="_list" v-if="serviceOpen == true">
          <div class="service_list" v-for="item, index in serviceList" :key="index">
            <img :src="item.picture" alt="" @click.stop="service(item)">
          </div>
        </div>
      </div>
    </keep-alive> -->
    <!-- <div class="_list" @click="serviceChange(1)">
      <img src="@/assets/new/goods/kefu2.png" alt="">
    </div> -->
    <div class="service" @click="serviceChange(0)">
      <img src="@/assets/new/goods/kefu.png" alt="">
    </div>
  </div>
</template>

<script>
import Tabbar from "@/components/Tabbar";
import LoadingRE from "@/components/LoadingRE";
import VueClipboard from "vue-clipboard2";
import { Toast, Badge, ActionSheet } from "vant";
import Cookies from "js-cookie";
import { GET_CONFIG_INFO, UNREAD_NUM } from "@tt/api";
import { Swipe, SwipeItem, Collapse, CollapseItem, Cell, Icon, Popup, ImagePreview, Dialog, Overlay, NoticeBar } from "vant";
import dataDetail from "@/utils/dataDetail";
import verConfig from "@/utils/verConfig";
import { getToken } from "@/utils/tools";
import Banner from "@/components/banner.vue";
import { Avatar } from "@tt/components";
// import Avatar from "@/components/avatar";
import HallMarquee from "@/components/hallMarquee.vue";
import { HOME_IMG } from "@/api";
import { Lans, getLanguage } from "@/i18n";
import { unsubscribeLotteryUser } from "@/utils/wss";
export default {
  components: {
    Popup,
    Tabbar,
    LoadingRE,
    VueClipboard,
    Toast,
    [ActionSheet.name]: ActionSheet,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Cell.name]: Cell,
    Banner,
    Avatar,
    HallMarquee,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    Badge,
    [Dialog.name]: Dialog,
    [Dialog.Component.name]: Dialog.Component,
    [Overlay.name]: Overlay
  },
  data() {
    this.Lans = Lans;
    return {
      gameActive: 0,
      token: getToken(),
      langicon: "",
      langtext: "",
      language: "",
      dialogShow: false,
      homeImg: "",
      verConfig,
      islocalImg: true,
      userInfo: {},
      country: Cookies.get("language"),
      bannerArr: [],
      noticeArr: [],
      inimenuArr: [{
        title: this.$t("newAdd.missionHall"),
        img: require("../../assets/icon/1.png"),
        activeImg: require("../../assets/icon/1-active.png"),
      },
      {
        title: this.$t("newAdd.helpCenter"),
        img: require("../../assets/icon/3.png"),
        activeImg: require("../../assets/icon/3-active.png"),
      },
      {
        title: this.$t("newAdd.inviteFriends"),
        img: require("../../assets/icon/7.png"),
        activeImg: require("../../assets/icon/7-active.png"),
      },
      ],
      menuArr: [],
      noticeArrss: [],
      menuVal: 0,
      allowed: 0,
      helpData: [],
      activeNames: 0,
      service_url: "",
      loadingNum: 0,
      noticeShowIndex: 3,
      unread: 0,
      ruleIsShow: false,
      show2: false,
      // merchants: [],
      jackpotNum: [],
      timer: null,
      gameArr: [{
        icon: require('../../assets/new/game/hot.png'),
        title: "hot",
      }],
      // {
      //   icon: require('../../assets/new/game/lottery.png'),
      //   title: "Lottery",
      // }, {
      //   icon: require('../../assets/new/game/slots.png'),
      //   title: "Slots",
      // }, {
      //   icon: require('../../assets/new/game/sabong.png'),
      //   title: "Sabong",
      // }, {
      //   icon: require('../../assets/new/game/fish.png'),
      //   title: "Fish",
      // }, {
      //   icon: require('../../assets/new/game/live.png'),
      //   title: "Live",
      // }, {
      //   icon: require('../../assets/new/game/poker.png'),
      //   title: "Poker",
      // }, {
      //   icon: require('../../assets/new/game/sports.png'),
      //   title: "Sports",
      // }, {
      //   icon: require('../../assets/new/game/esport.png'),
      //   title: "E-sports",
      // },
      overlayShow: false,
      list: [{
        icon: require('@/assets/new/goods/deposit_.png'),
        callback: (() => { this.RechargeEvent(); this.overlayShow = false }),
        title: '订金'
      }, {
        icon: require('@/assets/new/goods/withdraw_.png'),
        callback: (() => { this.WithdrawEvent(); this.overlayShow = false }),
        title: 'newAdd.Withdraw'
      }, {
        icon: require('@/assets/new/goods/refresh.png'),
        callback: (() => { this.getUserInfo(); this.overlayShow = false }),
        title: '刷新余额'
      }, {
        icon: require('@/assets/new/goods/hide.png'),
        icon1: require('@/assets/new/goods/open.png'),
        callback: (() => {
          this.isHide = !this.isHide;
          this.overlayShow = false
        }),
        title: '隐藏余额'
      }, {
        icon: require('@/assets/new/goods/help.png'),
        callback: (() => { this.$router.push('/helpCenter'); this.overlayShow = false }),
        title: 'newAdd.helpCenter'
      }, {
        icon: require('@/assets/new/goods/logout.png'),
        callback: (() => { this.logoutEvent(); this.overlayShow = false }),
        title: 'My.logout'
      },],
      isHide: false,
      serviceList: [],
      serviceOpen: false
    };
  },
  computed: {
    displayGameArr() {
      const base = [];
      const list = this.$store.getters.GameCategoryList || [];
      return list.length ? [...base, ...list] : base;
    },
    merchants() {
      return this.$store.getters.AllGameList;
    },
    gameList() {
      let _arr = this.$store.getters.GameCategoryList;
      let _type = _arr[this.gameActive]?.category || '';
      return this.merchants.filter(item => item.category == _type) || [];
    },
    hotMerchants() {
      return this.$store.getters.AllGameList.slice(0, 4);
    }
  },
  methods: {
    serviceChange(num) {
      this.getHome(num)
    },
    checkIn() {
      this.$router.push('/CheckIn')
    },
    service(item) {
      if (item.paramet.url) {
        window.location.href = item.paramet.url;
      }
      // this.$apis.toService()
    },
    swiperClick(item, index) {
      if (item.action === 'web_system') {
        if (item.paramet && item.paramet.url) {
          window.location.href = item.paramet.url
        }
      } else if (item.action === 'lottery_room') {
        if (item.paramet && item.paramet.lottery_type) {
          this.toGame({ type: item.paramet.lottery_type })
        }
      }
    },
    logoutEvent() {
      let _this = this;
      if (_this.userInfo.token) {
        Dialog.confirm({
          message: this.$t("My.logoutEvent"),
          cancelButtonText: this.$t("My.Button.One"),
          confirmButtonText: this.$t("My.Button.Two"),
        }).then(() => {
          let pwdState = _this.$cookie.get("the-pwd-state");
          let pwdObj = _this.$cookie.get("the-pwd-obj");
          unsubscribeLotteryUser();
          _this.$cookie.clear();
          _this.$cookie.set("the-pwd-state", pwdState);
          _this.$cookie.set("the-pwd-obj", pwdObj);
          _this.$router.push("/login");
        }).catch(() => { });
      } else {
        this.$router.push("/login");
      }
    },
    gameClick(index) {
      if (index == this.gameActive) return;
      this.gameActive = index;
      this.$cookie.set('gameNum', index)
      return;
      if (index == 1 || index == 0) {
      }
      Toast(this.$t('无法打开'))
    },
    noGameClick() {
      Toast(this.$t('正在维护中'));
    },
    async getHome(num) {
      Toast.loading()
      try {
        const { data } = await HOME_IMG();
        Toast.clear()
        if (data) {
          if (data[num]) return data[num].paramet.url && (window.location.href = data[num].paramet.url);
          const find = data.find(item => item.paramet.url);
          find.paramet.url && (window.location.href = find.paramet.url);
        }
        // this.serviceList = data
        // this.serviceOpen = !this.serviceOpen
      } catch (error) {
        Toast.clear();
        // if(error.data.url) return window.location.href = error.data.url;
      }
    },
    showRule() {
      // this.ruleIsShow = true;
      ImagePreview([require("@tt/assets/home/rule.jpg")]);
    },
    showLang() {
      this.show2 = true;
    },
    onClose() {
      this.show2 = false;
    },
    onSelect(e) {
      this.$i18n.Locale = e.value;
      this.changeLanguage(e.value);
      Cookies.set("lang", e.value);
      this.language = e.value;
      this.show2 = false;
      this.langicon = e.icon;
      this.langtext = e.name;
    },
    async getUnread() {
      this.loadingNum++;
      try {
        const res = await UNREAD_NUM();
        res && (this.unread = res);
        this.loadingNum--;
      } catch (error) {
        this.loadingNum--;
      }
    },
    // add:点击充值的按钮
    RechargeEvent() {
      this.$router.push("/new-recharge");
    },
    // add 分享
    goshare() {
      this.$router.push("/inviteFriends");
    },
    // add:点击提现按钮
    WithdrawEvent() {
      this.$router.push({ name: "newWithdraw" });
    },
    // add:去下载
    downloadEvent() {
      if (localStorage.getItem("android")) {
        location.href = localStorage.getItem("android");
      } else {
        location.href = "http://www.baidu.com";
      }
    },
    // add/随机名字
    randName() {
      let name =
        String(dataDetail.rand(72, 99)) +
        dataDetail.rand(3, 9) +
        "****" +
        parseInt(Math.random() * 10) +
        parseInt(Math.random() * 10) +
        parseInt(Math.random() * 10);
      return name;
    },
    // add/随机
    randMoney() {
      let probability = dataDetail.rand(0, 100);
      if (probability <= 30) {
        return dataDetail.rand(100, 10000);
      } else {
        return dataDetail.rand(10000, 300000);
      }
    },
    // add:lunbo
    noticeIni() {
      for (let i = 0; i < 12; i++) {
        this.noticeArrss.push({
          name: this.randName(),
          money: this.randMoney(),
        });
      }
      // console.log(this.noticeArrss);
    },
    // add:lunbo
    noticeDataUpdate() {
      setInterval(() => {
        this.noticeArrss.splice(this.noticeShowIndex, 1, {
          name: this.randName(),
          money: this.randMoney(),
        });
        if (this.noticeShowIndex >= 4) {
          this.noticeShowIndex = 1;
        } else {
          this.noticeShowIndex++;
        }
      }, 3000);
    },
    toInvite() {
      this.$router.push({ name: "InviteFriends" });
    },
    toRecharge() {
      Dialog.alert({
        title: this.$t("My.MemberInformation.Recharge"),
        message: this.$t("hint.lxkf"),
        showCancelButton: true,
        confirmButtonText: this.$t("Login.goLoginText"),
        cancelButtonText: this.$t("newAdd.Cancel"),
      })
        .then(() => {
          this.$api.toService();
        })
        .catch(() => { });
      return;
      // this.$router.push({ name: "NewRecharge" });
    },
    toService() {
      this.$api.toService();
    },
    toWithdraw() {
      this.$router.push({ name: "newWithdraw" });
    },
    copySuccess() {
      // Toast('Copy success!')
      Toast(this.$t("newAdd.copySuccess"));
    },
    copyError() {
      // Toast('Copy the failure!')
      Toast(this.$t("newAdd.copyError"));
    },
    menuChange(val) {
      this.menuVal = val;
    },
    handleChange(val) { },
    // 获取用户信息
    getUserInfo() {
      this.loadingNum++;
      if (!this.userInfo.level) {
        this.$api.getUserInfo(
          (res) => {
            if (res.identity.indexOf("agent") == -1) {
              this.inimenuArr.splice(2, 1);
            }
            this.userInfo = res;
            this.loadingNum--;
            // Toast.clear()
          },
          (err) => {
            // Toast.clear()
            this.loadingNum--;
          }
        );
      }
    },
    toUnlock() {
      this.$router.push({ name: "levelUpgrade" });
    },
    getNotice() {
      this.$api.getNotice((res) => {
        this.noticeArr.push(res.scroll_notice);
        this.service_url = res.service_url;
        localStorage.setItem("android", res.appurl_android);
        localStorage.setItem("service_url", res.service_url);
      });
    },
    getBanner() {
      this.loadingNum++;
      this.$api.getBanner(
        (res) => {
          this.loadingNum--;
          if (res.length) {
            this.bannerArr = res;
            this.islocalImg = false;
          }
        },
        (err) => {
          this.loadingNum--;
        }
      );
    },
    getConfigShare() {
      this.loadingNum++;
      GET_CONFIG_INFO({
        act: "share",
      })
        .then((r) => {
          this.loadingNum--;
          if (r.data.ret === 1) {
            this.inviteLink = r.data.data.text;
            this.$cookie.set("public-share-item", JSON.stringify(r.data.data));
          } else {
            this.inviteLink = "";
            this.$cookie.set("public-share-item", {});
          }
        })
        .catch((e) => {
          console.error(e);
          this.loadingNum--;
        });
    }, // 获取分享地址
    getMenuArr() {
      this.loadingNum++;
      this.$api.getHomeConfig(
        (res) => {
          this.loadingNum--;
          this.menuArr = res.lists;
        },
        (err) => {
          this.loadingNum--;
        }
      );
    },
    getHelpArr() {
      this.loadingNum++;
      this.$api.getHomeHelp(
        (res) => {
          // console.log(res);
          this.loadingNum--;
          for (let i = 0; i < res.lists.length; i++) {
            let res_item = res.lists[i];
            res_item.content = res_item.content.replace(/<[^>]*>/gi, "");
          }
          this.helpData = res.lists;
        },
        (err) => {
          this.loadingNum--;
        }
      );
    },
    // 获取商家(玩法)数据
    // async getMerchants() {
    //   try {
    //     const res = await $post("/lottery/setting");
    //     const { ret, msg, data } = res.data;
    //     this.merchants = data;
    //     this.$cookie.set("merchants", JSON.stringify(this.merchants));
    //   } catch (error) {}
    // },
    // 进入玩法
    toGame(item) {
      if (item.category == 'animal') {
        return this.$router.push(`/Game_animal?type=${item.type}`);
      }
      if (item.category == 'wingo') {
        return this.$router.push(`/Game_qq?type=${item.type}`)
      }
      return this.$router.push(`/Game?type=${item.type}`);
    },
    toGames(item) {
      if (item.category == 'animal') {
        return this.$router.push(`/Game_animal?type=${item.type}`);
      }
      if (item.category == 'wingo') {
        return this.$router.push(`/Game_qq?type=${item.type}`)
      }
      return this.$router.push(`/Game?type=${item.type}`);
      return;
      if (item.types[0].indexOf('qq') > -1) {
        return this.$router.push(`/Game_qq?type=${item.types[0]}`)
      }
      this.$router.push(`/Game?type=${item.types[0]}`);
    },
    generateRandomNumber() {
      let num = localStorage.getItem("randomNumber");
      if (num) {
        return parseFloat(num);
      }
      let integerPart = 100000000 + Math.floor(Math.random() * 90000000);
      let decimalPart = Math.random().toFixed(9).substring(2);
      let randomNumber = parseFloat(`${integerPart}.${decimalPart}`);
      localStorage.setItem("randomNumber", randomNumber);
      return parseFloat(randomNumber);
    },
    addRandomIncrement() {
      let currentNumber = this.generateRandomNumber();
      this.allNum(currentNumber);
      this.timer = setInterval(() => {
        this.allNum(currentNumber);
      }, 5000);
    },
    allNum(currentNumber) {
      let increment = (Math.random() * 1000).toFixed(9);
      currentNumber += parseFloat(increment);
      let num = currentNumber.toFixed(2);
      let num1 = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      let arr = num1.split("");
      this.jackpotNum = arr;
    },
  },
  created() {
    Toast.loading();
    this.getUserInfo();
    this.$store.dispatch("getGameCategory");
    this.gameActive = this.$cookie.get('gameNum') || 0
    this.addRandomIncrement();
    this.getNotice();
    this.getBanner();
    this.getConfigShare();
    // this.getMenuArr();
    // this.getHelpArr();
    this.getUnread();
    // this.getHome();
    this.$store.dispatch("getGameList");
    // this.getMerchants();
    Lans.forEach((item) => {
      if (item.value == getLanguage()) {
        this.langicon = item.icon;
        this.langtext = item.name;
      }
    });
  },
  mounted() {
    if (!this.$cookie.get("token")) {
      this.inimenuArr.splice(2, 1);
    }
    this.noticeIni();
    // this.noticeDataUpdate();
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
  watch: {
    loadingNum: (newVal) => {
      Toast.loading({
        forbidClick: true,
        duration: 0,
      });
      if (!newVal) {
        setTimeout(() => {
          Toast.clear();
        }, 1000);
      }
      setTimeout(() => {
        Toast.clear();
      }, 10000);
    },
  },
};
</script>

<style lang="less" scoped>
@import url("../../assets/iconfonts/iconfont.css");
// @Color: #e23d6d;
@Color: var(--theme);
@comColor: var(--theme);
@wrapShadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
@wrapPadding: calc(12rem / 16);
@comRadius: 10px;
// @comBG: linear-gradient(#093958, #022c47);
@comBG: var(--bg1);

// 弹性布局
.flex(@JC: center; @FW: nowrap; @AI: center; @FD: row) {
  display: flex;
  flex-wrap: @FW;
  flex-direction: @FD;
  justify-content: @JC;
  align-items: @AI;
}

// 文字超出省略号
.text-overflow(@num: 1) {
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: @num;
}

.spancolor {
  color: @Color;
}

.checkIn,
.service {
  position: fixed;
  right: calc(10rem / 16);
  bottom: calc(70rem / 16);
  z-index: 10;

  img {
    width: calc(44rem / 16);
    height: calc(44rem / 16);
    display: block;
    animation: moveUpDown .8s infinite alternate;
  }

  @keyframes moveUpDown {
    0% {
      transform: scale(1);
    }

    100% {
      transform: scale(1.2);
    }
  }
}

.transtions {
  transition: transform 0.3s ease, opacity 0.3s ease;
  opacity: 1;
}

.transtions[style*="display: none"] {
  opacity: 0;
}

._list {
  position: fixed;
  right: calc(10rem / 16);
  bottom: calc(130rem / 16);
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: calc(15rem / 16);

  img {
    width: calc(44rem / 16);
    height: calc(44rem / 16);
    display: block;
    animation: moveUpDown .8s infinite alternate;
  }

  @keyframes moveUpDown {
    0% {
      transform: scale(1);
    }

    100% {
      transform: scale(1.2);
    }
  }
}

.checkIn {
  bottom: calc((130rem + (60rem * var(--num))) / 16);

  img {
    animation: moveUpDown .8s infinite alternate;
  }

  @keyframes moveUpDown {
    0% {
      transform: scale(1);
    }

    100% {
      transform: scale(1.2);
    }
  }
}

.userInfo_left {
  display: flex;
  align-items: center;
  column-gap: 5px;

  .icon_lang {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #eee;
    border-radius: 6px;
    padding: 0 5px;

    img {
      height: 40px;
      width: 40px;
      object-fit: contain;
    }

    span {
      min-width: 55px;
      margin-left: 10px;
      color: #fff;
      font-size: calc(14rem / 16);
    }
  }
}

.wrap {
  // background: #f5f5f5;
  min-height: 100vh;
  overflow: hidden;
  background-color: var(--main_bg);

  .swiper {
    background-size: 100% 100%;
    padding: @wrapPadding calc(10rem / 16);
    // background: @comColor;
    background: var(--navBg);
    // height: 200px;
    color: var(--textColor);
    // color: @comColor;

    .title_userinfo {
      // .flex(space-between);
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .logo {
        // height: calc(30rem / 16);
        height: calc(35rem / 16);
        display: block;
        // margin: 0 auto;
      }

      .right {
        display: flex;
        align-items: center;

        .icon_rule {
          color: var(--gray2);
          margin-right: calc(15rem / 16);

          >i {
            font-size: calc(26rem / 16);
          }
        }

        .share_content {
          margin-left: calc(10rem / 16);

          img {
            width: calc(24rem / 16);
            display: block;
          }
        }

        .userInfo {
          display: flex;
          align-items: center;

          .userInfo_left {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-right: 10px;

            .left_name {
              font-size: calc(12rem / 16);
              color: var(--light);
            }

            .left_money {
              font-size: calc(12rem / 16);
              color: #ffe224;
            }
          }

          .userInfo_right {
            display: flex;
            align-items: center;
            gap: calc(10rem / 16);

            .right_btn {
              img {
                height: calc(22rem / 16);
                display: block
              }
            }
          }
        }
      }

      .info {
        .flex(start);

        .contentLeft_Vip {
          background: rgba(255, 255, 255, 0.2);
          // background: rgba(0, 0, 0, 0.2);
          text-align: center;
          border-radius: 20px;
        }
      }

      .right {
        .user {
          margin-left: 2vw;

          >div {
            margin-top: calc(10rem / 16);

            &:nth-child(1) {
              margin-top: 0;
            }

            .label {
              color: var(--gray1);
            }

            .value {
              color: var(--textColor);
            }
          }
        }

        .btn {
          height: calc(24rem / 16);
          line-height: calc(24rem / 16);
          color: #fff;
          font-size: calc(12em / 16);
          padding: 0 calc(10rem / 16);
          min-width: calc(45rem / 16);
          border-radius: calc(170rem / 16);
          text-align: center;
        }

        .login {
          background: linear-gradient(180deg,
              #ffe692,
              #ffd759 35.5%,
              #ffe58e 67.75%,
              #f79c17);
          color: #961f1f;
          border: 1px solid transparent;
        }

        .register {
          margin-left: calc(10rem / 16);
          border: 1px solid #fff;
        }
      }
    }
  }

  .notice {
    margin-top: calc(5rem / 16);
    display: flex;
    align-items: center;
    padding: 0 calc(7.5rem / 16);
    background: linear-gradient(180deg,
        #ffe692,
        #ffd759 35.5%,
        #ffe58e 67.75%,
        #f79c17);
    border-radius: 70px;
    height: 30px;
    line-height: 30px;

    .notice_bar {
      flex: 1;
      min-width: 0;
      height: 30px;
      padding: 0 !important;
      color: #961f1f;
      background: transparent !important;
      font-size: 14px;
    }

    /deep/ .van-notice-bar__wrap {
      height: 30px;
      line-height: 30px;
    }

    /deep/ .van-notice-bar__left-icon {
      margin-right: 8px;
      color: #961f1f;
    }

    /deep/ .van-notice-bar__content {
      will-change: transform;
      backface-visibility: hidden;
      -webkit-backface-visibility: hidden;
    }
  }

  .jackpot-container {
    .jackpot_bg {
      position: relative;
      width: 100%;
      height: calc(93rem / 16);
      margin-bottom: calc(10rem / 16);
      background: url(../../assets/new/jackpot_bg.png) no-repeat;
      background-size: 100% 100%;

      .jackpot_num {
        position: absolute;
        bottom: calc(15rem / 16);
        left: 50%;
        display: flex;
        align-items: end;
        transform: translateX(-50%);
        column-gap: calc(3rem / 16);

        .num {
          width: calc(20rem / 16);
          height: calc(28rem / 16);
          background: linear-gradient(180deg,
              #ffe692,
              #ffd759 35.5%,
              #ffe58e 67.75%,
              #f79c17);
          background-clip: content-box, border-box;
          background-origin: border-box;
          border-radius: calc(6rem / 16);
          box-shadow: 0 .03866rem .03866rem 0 rgba(0, 0, 0, .25);
          -webkit-clip-path: inset(0 round 1.597px);
          clip-path: inset(0 round 1.597px);
          display: flex;
          align-items: center;
          justify-content: center;

          span {
            display: inline-block;
            font-size: calc(20rem / 16);
            font-weight: bold;
            background: linear-gradient(1turn, #470707 .03%, #953535 99.97%);
            text-align: center;
            background-clip: text;
            color: transparent
          }
        }

        .point {
          span {
            display: inline-block;
            font-size: calc(24rem / 16);
            font-weight: bold;
            background: linear-gradient(180deg, #ffe692, #ffd759 35.5%, #ffe58e 67.75%, #f79c17);
            text-align: center;
            background-clip: text;
            color: transparent
          }
        }
      }
    }
  }

  .banner_wrap {
    margin: @wrapPadding;
    background: var(--main_bg);
    border-radius: 10px;
    overflow: hidden;
    // box-shadow: @wrapShadow;
  }

  .title_balance {
    .user_content {
      width: 85%;
      margin: 0 auto;
      margin-top: 4vw;
      padding: 3vw 4vw;
      background-color: rgba(255, 255, 255, 0.2);
      // box-shadow: 0 0 2.667vw rgba(0, 0, 0, 0.2);
      border-radius: 1.333vw;

      .balance_wrap {
        .balance_case {
          .case_bottom {
            font-size: 12px;
          }

          text-align: center;
          .flex(space-between);
        }

        padding: 2vw 3vw;

        .balance_text {
          margin-bottom: 5vw;
        }

        .hr {
          width: 118%;
          border-top: 1px solid #de3d6d;
          border-bottom: 1px solid #ea84a3;
          margin: 5vw 0;
          margin-left: -7vw;
        }

        .contentCase_btns {
          .flex(space-around);

          .contentCase_btn {
            padding: 1.867vw 2vw;
            font-size: 3.733vw;
            line-height: normal;
            // color: #004986;
            color: var(--textColor);
            text-align: center;
            border-radius: 7.467vw;
            // background-color: #fff;
            background-color: @comColor;
            margin-left: 2vw;
          }
        }

        .moey_num {
          color: @Color;
          font-size: 6.4vw;
          font-weight: 400;
        }
      }
    }
  }

  .download {
    background-color: #f5f4f7;
    padding: 5vw 0;

    .download_content {
      .flex(space-between);
      width: 85vw;
      margin: 0 auto;
      background-color: #fff;
      // box-shadow: 0 0 2.667vw rgba(0, 0, 0, 0.05);
      border-radius: 2.667vw;
      padding: 3vw;

      img {
        width: 30px;
      }
    }
  }

  // .people {
  //   .people_title {
  //     color: @Color;
  //     width: 100%;
  //     height: 6.333vw;
  //     padding: 4vw 4vw;
  //     font-weight: 700;
  //     position: relative;
  //     text-indent: 4vw;
  //     line-height: 7vw;
  //   }

  //   .people_title::before {
  //     display: block;
  //     content: "";
  //     background-color: @Color;
  //     width: 2vw;
  //     height: 6vw;
  //     position: absolute;
  //     border-radius: 2vw;
  //   }

  //   .marquee {
  //     height: 35vw;
  //   }

  //   .halloffame {
  //     padding: 0 5vw;
  //     line-height: 3em;
  //     font-size: 13px;
  //   }
  // }
  .hall {
    margin: @wrapPadding;
    padding: @wrapPadding;
    // background: var(--moduleColor);
    border-radius: @comRadius;

    .title {
      color: var(--gold);
      margin-bottom: calc(5rem / 16);
    }

    .marquee {
      .item {
        padding: calc(10rem / 16) calc(15rem / 16);
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left {
          display: flex;
          font-size: calc(14rem / 16);

          .info {
            margin-left: calc(4rem / 16);
            padding: 1px 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            color: var(--light);
            font-size: calc(12rem / 16);
            gap: calc(10rem / 16);

            &_money {
              font-size: calc(15rem / 16);
            }
          }
        }

        .right {
          min-width: calc(70rem / 16);
          max-width: calc(110rem / 16);
          padding: 0 calc(5rem / 16);
          font-size: calc(12rem / 16);
          color: #df8c8c;
          border: 1px solid #df8c8c;
          border-radius: calc(50rem / 16);
          text-align: center;
          height: calc(30rem / 16);
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      >div:nth-child(2n+1) {
        .item {
          background: linear-gradient(180deg, #ffe692, #ffd759 35.5%, #ffe58e 67.75%, #f79c17);

          .info {
            color: #961f1f;
          }

          .right {
            color: var(--light);
            background: linear-gradient(99.59deg, #470707 -4.56%, #9b0000 33.89%, #7e1414 74.63%, #470707 110.2%);
          }
        }
      }
    }
  }

  .hall_bg {
    margin: @wrapPadding;

    .img {
      width: 100%;
      display: block;
      height: calc(210rem / 16);
      border-radius: calc(10rem / 16);
    }
  }

  .game {
    padding: 0 calc(12rem / 16);

    .game_wrap {
      display: flex;
      // overflow-x: auto;
      column-gap: calc(12rem / 16);
      // scrollbar-width: none;
      // -ms-overflow-style: none;

      .game_item {
        position: relative;
        font-weight: bold;
        flex-shrink: 0;
        flex: 1;
        // min-width: calc(77rem / 16);
        // height: calc(55rem / 16);
        overflow: hidden;
        text-align: center;
        background: linear-gradient(1turn, #470707 .03%, #953535 99.97%);
        border: 1px solid #470707;
        border-radius: calc(5rem / 16);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: calc(10rem / 16) 0;

        img {
          width: calc(30rem / 16);
          height: calc(30rem / 16);
          display: block;
        }

        color: #df8c8c;
        font-size: calc(12rem / 16);

        .title {
          margin-top: calc(3rem / 16);
        }
      }

      .item_active {
        background: linear-gradient(180deg, #ffe692, #ffd759 35.5%, #ffe58e 67.75%, #f79c17);
        color: #961f1f;
      }
    }
  }

  .btns_wrap {
    margin: @wrapPadding;
    display: flex;
    // justify-content: space-between;
    // @itemGap: calc(10rem / 16);
    @itemGap: @wrapPadding;
    // box-shadow: @wrapShadow;

    .btn_item {
      padding: calc(6rem / 16) 0;
      // background: #002c47;
      // background: linear-gradient(#093a58, #002c47);
      background: var(--moduleColor);
      // color: @comColor;
      color: var(--gold);
      font-size: calc(12rem / 16);
      text-align: center;
      width: calc((100vw - @wrapPadding * 2 - @itemGap * 2) / 3);
      margin-left: @itemGap;
      border-radius: 6px;
      // box-shadow: @wrapShadow;

      &:nth-of-type(1) {
        margin-left: 0;
      }

      >i {
        font-size: calc(32rem / 16);
        color: #00bbfe;
      }

      img {
        height: calc(32rem / 16);
        color: #00bbfe;
      }

      .text {
        margin-top: calc(10rem / 16);
      }

      /deep/ .van-badge--fixed {
        top: calc(6rem / 16);
        right: calc(5rem / 16);
      }
    }
  }

  .all_game {
    margin: @wrapPadding;
    border-radius: @comRadius;
    overflow: hidden;

    /deep/ .van-cell {
      background: #063451;

      .van-cell__title {
        color: #00bbfe;
      }

      .van-cell__value {
        color: #8ba6c1;
      }

      .van-cell__right-icon {
        color: #8ba6c1;
      }
    }
  }

  .shop_wrap {
    // padding: 5px;
    margin: @wrapPadding;
    // background-color: #f5f5f5;
    // background: #fff;
    // padding-bottom: @wrapPadding;
    // box-shadow: @wrapShadow;
    @radius: @comRadius;
    border-radius: @radius;

    .content_wrap {
      // background-color: #fff;
      border-radius: @radius;
      overflow: hidden;

      // padding: calc(5rem / 16);
      .not_game {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        position: relative;
        color: #c3c3c3;
        font-size: 14px;

        img {
          width: 100%;
        }
      }
    }

    .merchants_wrap {
      display: flex;
      flex-direction: column;
      gap: @wrapPadding;

      .merchant_item {
        // border-radius: 8px;
        text-align: center;
        // background: url(../../assets/new/goods/game_bg.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: calc(12rem / 16);
        height: calc(120rem / 16);
        overflow: hidden;

        .item_left {
          .title {
            font-size: 20px;
            // color: var(--light);
            text-align: left;
            font-weight: 700;
            margin-top: calc(8rem / 16);
            background: linear-gradient(87deg, #E88719 -2%, #FFFCD6 22%, #EFA003 99%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            font-style: italic;
          }

          .subtitle {
            font-size: 12px;
            color: var(--gameSizeColor);
            margin-top: calc(4rem / 16);
            text-align: left;
            color: rgba(255, 255, 255, 0.6);
            ;
          }

          .btn {
            width: fit-content;
            background: linear-gradient(181deg, #FBE599 2%, #F9DB76 49%, #FBE699 70%, #EEB452 96%);
            border: 2px solid #731F1A;
            color: #550D17;
            font-size: calc(16rem / 16);
            padding: calc(5rem / 16) calc(15rem / 16);
            line-height: 1;
            border-radius: calc(20rem / 16);
            margin-top: calc(20rem / 16);
          }

        }

        img {
          height: 150%;
          margin-right: calc(-30rem / 16);
          margin-bottom: -40px;
        }
      }

      .hl {
        img {
          height: 120%;
          margin-right: 0;
          margin-bottom: 25px;
        }
      }

      .qq {
        img {
          height: 140%;
          margin-right: -10px;
          margin-bottom: 16px;
        }
      }
    }
  }
}

.close {
  position: absolute;
  top: 5px;
  right: 5px;

  .icon {
    font-size: 20px;
    color: #000;
  }
}

/deep/ .van-overlay {
  display: flex;
  justify-content: flex-end;

  .overlay {
    background-color: #470707;
    border-radius: 10px;
    padding: 10px;
    max-width: 200px;
    box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .34);
    color: var(--light);
    margin-top: 50px;
    height: fit-content;
    display: flex;
    flex-direction: column;
    gap: calc(11rem / 16);
    margin-right: 10px;

    &_item {
      display: flex;
      align-items: center;
      gap: calc(10rem / 16);

      img {
        width: calc(20rem / 16);
        height: calc(20rem / 16);
        display: block;
      }

      span {
        font-size: calc(12rem / 16);
        color: var(--light);
      }
    }
  }
}
</style>
